<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">Usuarios</h1>
          <b-spinner v-if="loading" variant="primary" class="ml-2" small label="Small Spinner"></b-spinner>
        </b-col>
        <b-col>
          <user-edit @on-save-success="getData"></user-edit>
        </b-col>
      </b-row>

      <v-client-table :data="tableData" :columns="columns" :options="options" v-if="ready">
        <template #is_active="props">
          <b-form-checkbox disabled v-model="props.row.is_active" />
        </template>
        <template #is_staff="props">
          <b-form-checkbox disabled v-model="props.row.is_staff" />
        </template>
        <template #last_login="props">
          {{ props.row.last_login | datetime }}
        </template>
        <template v-slot:actions="props">
          <user-edit :id="props.row.id" @on-save-success="getData"></user-edit>
        </template>
      </v-client-table>
    </div>
  </div>
</template>

<script>
import UserEdit from "./UserEdit.vue";
import moment from "moment";
export default {
  name: "Users",
  components: {
    UserEdit
  },
  data() {
    return {
      ready: false,
      loading: true,
      columns: [],
      tableData: [],
      options: {
        columnsClasses: {
          actions: "w-5 text-center",
          is_active: "w-5 text-center",
          is_staff: "w-5 text-center"
        }
      }
    };
  },
  filters: {
    datetime(value) {
      return moment(value).format("DD/MM/YYYY HH:mm:ss");
    }
  },
  methods: {
    async getData() {
      try {
        const response = await this.$axios.get("/menu/user/?omit=scope&no_page");
        this.tableData = response.data;
        this.columns = Object.keys(response.data[0]);
        this.columns.push("actions");
        this.ready = true;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.ready = true;
        this.loading = false;
      }
    }
  },
  mounted() {
    moment.locale("es");
    this.getData();
  }
};
</script>

<style scoped>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
